import { useRootInstance } from 'common-module/src/util/useRootInstance';
import { startCustomDriver } from './customDriver';
import { sleep } from '@/utils';
import { guideRecord } from '@/api/overseasGuide';
import { checkIsInstallChromeRecorderExtension } from '@/utils/recorderExtension';
import { waitGetAny } from '@zk/framework-vue';
const RECORDER_FUNCTION_GUIDE_TYPE = 52;

let currentConfig;
let currentGuideIndex;
let guide;
let newGuideKey;
let newGuideName;

const config = {
  CHECK_SCREEN_RECORD:[
    {
      selector: '.zk-issue-detail-field-description .zk-editor-content',
      scopeName: 'check-screen-recorder-1',
      popover: {
        title: 't(overseasGuide.newScreenRecord.title0)',
        description: 't(overseasGuide.newScreenRecord.description0)',
        position: 'right-bottom'
      },
      clickToNext: true,
      addScopeCss: (name) => {
        return `
          .${name} .el-drawer__wrapper {
            position: absolute;
            z-index: auto !important;
          }
          .${name} .zk-issue-detail-field-description .zk-editor-content {
            background: #fff;
          }
          .${name} .zk-video-player-dialog {
            z-index: 9999999999999999999 !important;
          }
        `;
      },
      beforeCreateDriver: async ()=> {
        const editor = document.querySelector('.zk-issue-detail-field-description .share-editor');
        editor?.classList.add('in-edit');
        editor?.classList.add('expand');
        const scroll = document.querySelector('.zk-issue-detail-left-field-area .el-scrollbar__wrap');
        if (scroll) {
          setTimeout(() => {
            scroll.scrollTop = 0;
          }, 0);
        }
        await sleep(100);
        return !!newGuideKey;
      }
    },
    {
      selector: '.zk-issue-detail-field-description .editor-right-toolbar .index_btn_1t5Bf',
      scopeName: 'check-screen-recorder-2',
      clickToNext: true,
      popover: {
        title: 't(overseasGuide.newScreenRecord.title0)',
        description: 't(overseasGuide.newScreenRecord.description1)<span class="show-not-installed">&nbsp;t(recorderExtension.downloadTip)</span><div class="driver-popper-footer show-not-installed"><a target="_blank" href="https://chrome.google.com/webstore/detail/leiga-recorder/fbnihbofaecfcmcedpcmiginclpcdmoh" class="driver-popper-footer__btn install-extension-btn">t(recorderExtension.downloadBtn)</a></div>',
        position: 'top-end'
      },
      beforeCreateDriver: async ()=> {
        const editor = document.querySelector('.zk-issue-detail-field-description .share-editor');
        editor?.classList.add('in-edit');
        editor?.classList.add('expand');
        const scroll = document.querySelector('.zk-issue-detail-left-field-area .el-scrollbar__wrap');
        if (scroll) {
          scroll.scrollTop = 0;
        }
        await sleep(100);
        const isInstallExtension = await checkIsInstallChromeRecorderExtension();
        if (isInstallExtension) {
          document.body.classList.add('recorder-install-extension-installed');
        } else {
          document.body.classList.remove('recorder-install-extension-installed');
        }
        return !!newGuideKey;
      },
      beforeDestroyDriver () {
        document.body.classList.remove('recorder-install-extension-installed');
      },
      addScopeCss: (name) => {
        return `
          .${name} .el-drawer__wrapper {
            position: absolute;
          }
          .${name} .zk-issue-detail-field-description .zk-editor-toolbar{
            position: static;
            display: flex !important;
          }
          .${name} .driver-highlighted-element{
            background: #fff !important;
          }
          .${name} .driver-popper-footer {
            display: flex;
            margin-top: 16px;
            justify-content: flex-end;
          }
          .${name} .driver-popper-footer__btn {
            background: #fff;
            color: var(--primary-color);
            padding: 0 16px;
            border-radius: 8px;
            height: 33px;
            line-height: 32px;
            cursor: pointer;
          }
          .${name} .driver-popper-footer__btn:hover {
            opacity: 0.7;
          }
          .recorder-install-extension-installed .show-not-installed {
            display: none;
          }
        `;
      }
    }
  ],
  USE_SCREEN_RECORD_TO_REPORT_BUG: [
    {
      selector: '.zk-issue-detail-field-description #recorder-extract-btn',
      scopeName: 'other-recorder-1',
      popover: {
        title: 't(overseasGuide.newScreenRecord.title0)',
        description: 't(overseasGuide.newScreenRecord.description2)',
        position: 'right-bottom'
      },
      clickToStop: true,
      beforeCreateDriver: async ()=> {
        const editor = document.querySelector('.zk-issue-detail-field-description .share-editor');
        editor?.classList.add('in-edit');
        editor?.classList.add('expand');
        await sleep(300);

        // eslint-disable-next-line spellcheck/spell-checker
        if (document.querySelector('.zk-issue-detail-field-description [data-extract-show="true"]')) {
          currentGuideIndex = currentGuideIndex + 2;
          guide?.stop();
          await sleep(100);
          newGuideKey && startGuide(currentGuideIndex);
          return false;
        }
        return !!newGuideKey;
      },
      addScopeCss: (name) => {
        return `
          .${name} .el-drawer__wrapper {
            position: absolute;
          }
          .${name} .zk-issue-detail-field-description #recorder-extract-btn-warp {
            display: unset;
          }
          .${name} .zk-issue-detail-field-description #recorder-extract-btn {
            display: flex;
          }
        `;
      }
    },
    {
      selector: '[data-popper-name="ai-recommendation-summary"]',
      scopeName: 'other-recorder-2',
      popover: {
        title: 't(overseasGuide.screenRecord.title)',
        description: 't(overseasGuide.screenRecord.description7)',
        position: 'top-end'
      },
      beforeCreateDriver: async ()=> {
        const editor = document.querySelector('.zk-issue-detail-field-description .share-editor');
        editor?.classList.add('in-edit');
        editor?.classList.add('expand');
        return !!newGuideKey;
      },
      addScopeCss: (name) => {
        return `
        .${name} .el-drawer__wrapper {
          position: absolute;
        }
        .${name} [data-popper-name="ai-recommendation-summary"] {
          position: sticky !important;
        }
      `;
      }
    },
    {
      selector: '.zk-issue-detail-field-description .editor-right-toolbar .index_btn_1t5Bf',
      scopeName: 'other-recorder-3',
      clickToNext: true,
      popover: {
        title: 't(overseasGuide.newScreenRecord.title0)',
        description: 't(overseasGuide.newScreenRecord.description1)<span class="show-not-installed">&nbsp;t(recorderExtension.downloadTip)</span><div class="driver-popper-footer show-not-installed"><a target="_blank" href="https://chrome.google.com/webstore/detail/leiga-recorder/fbnihbofaecfcmcedpcmiginclpcdmoh" class="driver-popper-footer__btn install-extension-btn">t(recorderExtension.downloadBtn)</a></div>',
        position: 'top-end'
      },
      addScopeCss: (name) => {
        return `
          .${name} .el-drawer__wrapper {
            position: absolute;
          }
          .${name} .zk-issue-detail-field-description .zk-editor-toolbar{
            position: static;
            display: flex !important;
          }
          .${name} .driver-highlighted-element{
            background: #fff !important;
          }
          .${name} .driver-popper-footer {
            display: flex;
            margin-top: 16px;
            justify-content: flex-end;
          }
          .${name} .driver-popper-footer__btn {
            background: #fff;
            color: var(--primary-color);
            padding: 0 16px;
            border-radius: 8px;
            height: 33px;
            line-height: 32px;
            cursor: pointer;
          }
          .${name} .driver-popper-footer__btn:hover {
            opacity: 0.7;
          }
          .recorder-install-extension-installed .show-not-installed {
            display: none;
          }
        `;
      },
      beforeCreateDriver: async ()=> {
        const editor = document.querySelector('.zk-issue-detail-field-description .share-editor');
        editor?.classList.add('in-edit');
        await sleep(100);
        const scroll = document.querySelector('.zk-issue-detail-left-field-area .el-scrollbar__wrap');
        if (scroll) {
          scroll.scrollTop = 0;
        }
        const isInstallExtension = await checkIsInstallChromeRecorderExtension();
        if (isInstallExtension) {
          document.body.classList.add('recorder-install-extension-installed');
        } else {
          document.body.classList.remove('recorder-install-extension-installed');
        }
        return !!newGuideKey;
      },
      beforeDestroyDriver () {
        document.body.classList.remove('recorder-install-extension-installed');
      }
    }
  ],
  OTHER: [
    {
      selector: '.zk-issue-detail-field-description #recorder-extract-btn',
      scopeName: 'other-recorder-1',
      popover: {
        title: 't(overseasGuide.newScreenRecord.title0)',
        description: 't(overseasGuide.newScreenRecord.description2)',
        position: 'right-bottom'
      },
      clickToStop: true,
      beforeCreateDriver: async ()=> {
        const editor = document.querySelector('.zk-issue-detail-field-description .share-editor');
        editor?.classList.add('in-edit');
        editor?.classList.add('expand');
        await sleep(300);
        // eslint-disable-next-line spellcheck/spell-checker
        if (document.querySelector('.zk-issue-detail-field-description [data-extract-show="true"]')) {
          currentGuideIndex = currentGuideIndex + 2;
          guide?.stop();
          await sleep(100);
          newGuideKey && startGuide(currentGuideIndex);
          return false;
        }
        return !!newGuideKey;
      },
      addScopeCss: (name) => {
        return `
          .${name} .el-drawer__wrapper {
            position: absolute;
          }
          .${name} .zk-issue-detail-field-description #recorder-extract-btn-warp {
            display: unset;
          }
          .${name} .zk-issue-detail-field-description #recorder-extract-btn {
            display: flex;
          }
        `;
      }
    },
    {
      selector: '[data-popper-name="ai-recommendation-summary"]',
      scopeName: 'other-recorder-2',
      popover: {
        title: 't(overseasGuide.screenRecord.title)',
        description: 't(overseasGuide.screenRecord.description5)',
        position: 'top-end'
      },
      beforeCreateDriver: async ()=> {
        const editor = document.querySelector('.zk-issue-detail-field-description .share-editor');
        editor?.classList.add('in-edit');
        editor?.classList.add('expand');
        return !!newGuideKey;
      },
      addScopeCss: (name) => {
        return `
        .${name} .el-drawer__wrapper {
          position: absolute;
        }
        .${name} [data-popper-name="ai-recommendation-summary"] {
          position: sticky !important;
        }
      `;
      }
    },
    {
      selector: '.zk-issue-detail-field-description .editor-right-toolbar .index_btn_1t5Bf',
      scopeName: 'other-recorder-3',
      clickToNext: true,
      popover: {
        title: 't(overseasGuide.newScreenRecord.title0)',
        description: 't(overseasGuide.newScreenRecord.description1)<span class="show-not-installed">&nbsp;t(recorderExtension.downloadTip)</span><div class="driver-popper-footer show-not-installed"><a target="_blank" href="https://chrome.google.com/webstore/detail/leiga-recorder/fbnihbofaecfcmcedpcmiginclpcdmoh" class="driver-popper-footer__btn install-extension-btn">t(recorderExtension.downloadBtn)</a></div>',
        position: 'top-end'
      },
      addScopeCss: (name) => {
        return `
          .${name} .el-drawer__wrapper {
            position: absolute;
          }
          .${name} .zk-issue-detail-field-description .zk-editor-toolbar{
            position: static;
            display: flex !important;
          }
          .${name} .driver-highlighted-element{
            background: #fff !important;
          }
          .${name} .driver-popper-footer {
            display: flex;
            margin-top: 16px;
            justify-content: flex-end;
          }
          .${name} .driver-popper-footer__btn {
            background: #fff;
            color: var(--primary-color);
            padding: 0 16px;
            border-radius: 8px;
            height: 33px;
            line-height: 32px;
            cursor: pointer;
          }
          .${name} .driver-popper-footer__btn:hover {
            opacity: 0.7;
          }
          .recorder-install-extension-installed .show-not-installed {
            display: none;
          }
        `;
      },
      beforeCreateDriver: async ()=> {
        const editor = document.querySelector('.zk-issue-detail-field-description .share-editor');
        editor?.classList.add('in-edit');
        await sleep(100);
        const scroll = document.querySelector('.zk-issue-detail-left-field-area .el-scrollbar__wrap');
        if (scroll) {
          scroll.scrollTop = 0;
        }
        const isInstallExtension = await checkIsInstallChromeRecorderExtension();
        if (isInstallExtension) {
          document.body.classList.add('recorder-install-extension-installed');
        } else {
          document.body.classList.remove('recorder-install-extension-installed');
        }
        return !!newGuideKey;
      },
      beforeDestroyDriver () {
        document.body.classList.remove('recorder-install-extension-installed');
      }
    }
  ]
};

const titleMap = {
  USE_SCREEN_RECORD_TO_REPORT_BUG: 't(overseasGuide.newScreenRecord.title0)',
  USE_SCREEN_RECORD_SHARE_YOUR_IDEAS: 't(overseasGuide.newScreenRecord.title1)',
  EXTRACT_VOICE_FROM_VIDEO_FOR_CRITICAL_INFORMATION: 't(overseasGuide.newScreenRecord.title2)'
};

function onRecorderRecommendPopoverShow(value) {
  console.log(value);
  if (newGuideKey === 'CHECK_SCREEN_RECORD') {
    return;
  }
  if (currentGuideIndex === 0) {
    guide?.stop();
    if (value) {
      toNext();
    } else {
      currentGuideIndex++;
      toNext();
    }
  }
}

function onRecorderRecommendPopoverClose() {
  console.log('onRecorderRecommendPopoverClose');
  if (newGuideKey === 'CHECK_SCREEN_RECORD') {
    return;
  }
  if (currentGuideIndex === 1) {
    guide?.stop();
    setTimeout(() => {
      toNext();
    }, 100);
  }
}

function onIssueClose() {
  guide?.stop();
  onClose();
}

function initEventListener() {
  const instance = useRootInstance();

  // 录制视频解析推荐气泡

  instance.eventBus.$on('extract-recommended:show', onRecorderRecommendPopoverShow);

  // 录制视频解析推荐气泡关闭
  instance.eventBus.$on('extract-recommended-popper:close', onRecorderRecommendPopoverClose);

  instance.eventBus.$on('issue:closed', onIssueClose);
}

function offEventListener() {
  const instance = useRootInstance();

  // 录制视频解析推荐气泡

  instance.eventBus.$off('extract-recommended:show', onRecorderRecommendPopoverShow);

  // 录制视频解析推荐气泡关闭
  instance.eventBus.$off('extract-recommended-popper:close', onRecorderRecommendPopoverClose);

  instance.eventBus.$off('issue:closed', onIssueClose);
}

async function finishNewGuide() {
  const instance = useRootInstance();
  instance.eventBus.$emit('finish-guide-task', newGuideKey);
  //instance.$store.dispatch('overseasGuide/finishTask', newGuideKey);
  // 如果完成了新手引导，就不再展示功能引导
  if (!instance.$store.getters['guide/isDoneGuideByType'](RECORDER_FUNCTION_GUIDE_TYPE)) {
    await guideRecord(RECORDER_FUNCTION_GUIDE_TYPE);
    instance.$store.dispatch('guide/queryGuideInfo', true);
  }
}

function getCurrentStepConfig (index) {
  const stepConfig = currentConfig[index];
  if (titleMap[newGuideKey]) {
    stepConfig.popover.title = titleMap[newGuideKey];
  }
  const total = currentConfig.length;
  const progress = `${index + 1} / ${total}`;
  stepConfig.progress = progress;
  return stepConfig;
}

const toNext = () => {
  if (currentGuideIndex === currentConfig.length - 1) {
    finishNewGuide();
    onClose();
    return;
  }
  currentGuideIndex++;
  startGuide(currentGuideIndex);
};

const trackGuide = (key, value) => {
  const instance = useRootInstance();
  instance.$track.send(key, value, true);
};

function clear() {
  currentGuideIndex = null;
  guide = null;
  newGuideKey = null;
  newGuideName = null;
  offEventListener();
}

const onClose = () => {
  if (!newGuideKey) {
    return;
  }
  const instance = useRootInstance();
  const isLast = currentGuideIndex === currentConfig.length - 1;
  instance.eventBus.$emit('recorder:guide-close', isLast);
  instance.$track.send('Guide_DoneTask', { task_name: newGuideName, finish: isLast }, true);
  clear();
};

const onFooterBtnClick = (e) => {
  const installBtn = document.querySelector('.install-extension-btn');
  if (installBtn?.contains(e.target)){
    trackGuide('Click_Extension', { source: 'New_User_Guide' }, true);
    finishNewGuide();
    guide?.stop();
    onClose();
  }
};

async function startGuide(index) {
  currentGuideIndex = index;
  const stepConfig = getCurrentStepConfig(index);
  if (!stepConfig) {
    return;
  }
  const instance = useRootInstance();
  guide = await startCustomDriver(
    {
      config: stepConfig,
      onNext: toNext,
      onClose: onClose,
      onFooterBtnClick
    },
    instance
  );
}


async function awaitOpenIssueDetail(instance, issueData) {
  return new Promise(
    (resolve, reject) => {
      const onIssueClosed = () => {
        reject();
      };
      instance.eventBus.$emit('issue:edit', issueData || {});
      instance.eventBus.$on('issue:closed', onIssueClosed);
      waitGetAny(() => {
        return document.querySelector('.zk-issue-detail-field-description video');
      }, { interval: 50, timeout: 5000 }).then(resolve).catch(reject).finally(
        () => {
          instance.eventBus.$off('issue:closed', onIssueClosed);
        }
      );
    }
  );
}

export async function startRecorderUserGuide(key, name, issueData) {
  const instance = useRootInstance();
  if (!issueData?.id) {
    instance.$message.warning(instance.$t('guide.issueDeleteTip'));
    return;
  }
  // 打开详情
  await awaitOpenIssueDetail(instance, issueData);


  newGuideKey = key;
  newGuideName = name;
  currentConfig = config[newGuideKey] || config.OTHER;
  if (!currentConfig) {
    return;
  }
  currentGuideIndex = 0;
  startGuide(currentGuideIndex);
  offEventListener();
  initEventListener();
}
